import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import { FC, ReactElement } from 'react'
// import logo from './logo.svg'
import styled from 'styled-components'
// import Link from 'components/Link'

import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { Video } from 'components/video'

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : ''
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      {/* add your content here */}

      <Video
        mobileVideo={properties?.mobileVideo}
        desktopVideo={properties?.desktopVideo}
        mobilePoster={properties?.mobilePoster}
        desktopPoster={properties?.desktopPoster}
        title={properties?.title}
        lead={properties?.lead}
        width={
          properties?.width as
            | 'full'
            | 'content'
            | 'text'
            | 'left'
            | 'right'
            | 'leftandtext'
            | 'rightandtext'
            | 'textextended'
        }
        caption={properties?.caption}
        source={properties?.source}
        labelType={properties?.labelType as 'top' | 'bottom'}
        controls={
          properties?.controls === 'true'
            ? 'true'
            : properties?.controls === 'false'
            ? 'false'
            : undefined
        }
      ></Video>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  width: 100%;
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-family: var(--font-sans-serif);
  /* margin-left: auto;
  margin-right: auto; */
  /* color: var(--brandblue-main); */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  p {
    max-width: 400px;
  }
  /* @media (max-width: 599px) {
    margin-left: 1em;
    margin-right: 1em;
  } */

  .App-header {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 3rem;
    .tenant {
      ${props => (props.tenant ? `color: var(--tenant-${props.tenant})` : '')}
    }
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
export default MainComponent
